import axios from '@api/axios';

const axiosInstance = axios.create({
    baseURL: `/api/enquiries`
});

const index = function(paginatorOptions = null) {
    return axiosInstance.get('', {
        params: paginatorOptions
    });
};

const create = function(form) {
    return axiosInstance.post('', form);
};

const edit = function(form) {
    return axiosInstance.post(`${form.id}`, form);
};

const get = function(id) {
    return axiosInstance.get(id);
};

const cancel = function(id) {
    return axios.put(`/api/enquiries/${id}/cancel`);
};

const createBooking = function(enquiry) {
    return axios.put(`/api/enquiries/${enquiry.id}/create-booking`, enquiry);
};

const toVue = function(db) {
    let local = {};

    local.id = db.id;
    local.additionalInfo = db.client_notes;
    local.patients = [];
    local.appointmentDates = [];
    local.disciplineId = db.discipline_id;
    local.disciplineType = db.session_type.code;
    local.disciplineReport = db.reporting == 'with-report' ? 'yes' : 'no';
    local.appointmentPlace = db.preferred_address;
    local.appointmentAddress = {};

    if (local.appointmentPlace == 'other') {
        const dbAddress = db.preferred_session_address;

        local.appointmentAddress.city = dbAddress.city;
        local.appointmentAddress.county = dbAddress.county_id;
        local.appointmentAddress.line1 = dbAddress.line_1;
        local.appointmentAddress.line2 = dbAddress.line_2;
        local.appointmentAddress.latitude = dbAddress.latitude;
        local.appointmentAddress.longitude = dbAddress.longitude;
        local.appointmentAddress.postalCode = dbAddress.postal_code;
    }

    Object.entries(db.preferred_dates || {}).forEach((data) => {
        const date = data[1];

        local.appointmentDates.push({
            id: date.id,
            date: date.date,
            period: date.time_of_day
        });
    });

    Object.entries(db.patients || {}).forEach((data) => {
        const patient = data[1];

        local.patients.push({
            id: patient.id,
            additionalInfo: patient.additional_info,
            firstName: patient.first_name,
            lastName: patient.last_name,
            dateOfBirth: patient.date_of_birth
        });
    });

    return local;
};

export default { axios: axiosInstance, index, create, cancel, edit, get, createBooking, toVue };
